// extracted by mini-css-extract-plugin
export default {"cardWrapper":"NovostiDetaljno_cardWrapper__NS-yh","newsContent":"NovostiDetaljno_newsContent__Et+g6"};